import store from '@/store'
import { CONFIG } from '@/scripts/app-configs/constants'

import general from '@/http/endpoints/generalEndpoints'
import user from '@/http/endpoints/userEndpoints'
import patient from '@/http/endpoints/patientEndpoints'
import prescription from '@/http/endpoints/prescriptionEndpoints'
import patientsList from '@/http/endpoints/patientsListEndpoints'
import todoList from '@/http/endpoints/todoListEndpoints'
import institutions from '@/http/endpoints/institutionsEndpoints'
import notifications from '@/http/endpoints/notificationsEndpoints'
import recommendations from '@/http/endpoints/recommendationsEndpoints'
import results from '@/http/endpoints/resultsEndpoints'
import config from '@/http/endpoints/configEndpoints'
import dptActivity from '@/http/endpoints/dptActivityEndpoints'
import stepCountGoal from '@/http/endpoints/stepCountGoal'
import patientsFunnel from '@/http/endpoints/patientsFunnelEndpoints'
import activityReports from '@/http/endpoints/activityReportsEndpoints'
import metrics from '@/http/endpoints/metricsEndpoints'
import uml from '@/http/endpoints/unifiedMembersList'

// Move
import prescriptionMove from '@/http/endpoints/move/prescriptionEndpoints'
import membersMove from '@/http/endpoints/move/membersEndpoints'

//Bloom
import prescriptionBloom from '@/http/endpoints/bloom/prescriptionEndpoints'

export function generateAuthTokens() {
  return {
    authorization: { 'Authorization': store.getters['user/authentication/accessToken'] },
    refreshAuthorization: { 'Authorization': store.getters['user/authentication/refreshToken'] },
  }
}

export const endpointsSpec = {
  data: {
    // TODO Is this being used ?!
    apiUrls: {
      localized: CONFIG.baseUrl,
    },
    headers: generateAuthTokens(),
  },
  modules: {
    user,
    general,
    patient,
    prescription,
    patientsList,
    institutions,
    todoList,
    notifications,
    recommendations,
    results,
    config,
    dptActivity,
    patientsFunnel,
    stepCountGoal,
    activityReports,
    metrics,
    prescriptionMove,
    prescriptionBloom,
    membersMove,
    uml,
  },
}
